<div class="confirm-modal">
  <app-common-modal-form
    header="Mark as Signed"
    icon=""
    [isCustomFooter]="true"
    (close)="onClose()"
  >
    <div class="message form-group">{{ message }}</div>

    <div class="signing-contact form-group">
      <app-date-picker
        label="Sign Date"
        [formControl]="signingDateControl"
        [minDate]="minDate"
        [maxDate]="maxDate"
      />
    </div>

    @if (inSignedProcess) {
      <div class="my-2">
        <app-disclaimer
          color="orange"
          icon="ic-edit-20"
        >{{ signedWarning }}
        </app-disclaimer>
      </div>
    }

    <div class="custom-footer d-flex gap-24 justify-content-between">
      <div class="d-flex gap-24">
        @if (isDocument) {
          <button
            type="button"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="this.lodge()"
          >
            <i class="icon ic-send-20"></i>
            <span>Lodge</span>
          </button>
        }

        <button
          type="button"
          class="btn btn-primary d-flex align-items-center gap-2"
          (click)="this.markAsSigned()"
        >
          <i class="icon ic-send-20"></i>
          <span>Mark as Signed</span>
        </button>
      </div>

      <div>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="this.onClose()"
        >
          Cancel
        </button>
      </div>
    </div>
  </app-common-modal-form>
</div>
